import Users from './users';

export default {
  namespaced: true,
  modules: {
    Users,
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/access_provider/index.js